export type ContinueDestination = 'overview' | 'intakeForm' | 'carrierSelect';

// Single source of truth for where the landing Continue button goes —
// used for both navigation and the funnel event's `destination` prop,
// so the two can never disagree (INS-1296).
export function resolveContinueDestination(
  hasSubmissions: boolean,
  showIntakeForm: boolean,
): ContinueDestination {
  if (hasSubmissions) return 'overview';
  if (showIntakeForm) return 'intakeForm';
  return 'carrierSelect';
}
